import { Instance, types } from 'mobx-state-tree';
import { EducationQualifications } from './EducationQualifications';
import { EmploymentExperiences } from './EmploymentExperiences';

export const Inquiry = types.model('InquiryModel', {
  id: types.string,
  inquirerName: types.maybe(types.string),
  firstName: types.maybe(types.string),
  middleName: types.maybe(types.string),
  lastName: types.maybe(types.string),
  city: types.maybe(types.string),
  date: types.maybe(types.Date),
  inquirerContactNo: types.maybe(types.string),
  inquirerEmail: types.maybe(types.string),
  dateOfBirth: types.maybe(types.Date),
  gender: types.maybeNull(types.string),
  educationQualifications: types.maybe(types.array(EducationQualifications)),
  employmentExperiences: types.maybe(types.array(EmploymentExperiences)),
  courseID: types.maybe(types.string),
  preferredYear: types.maybeNull(types.number),
  intakeID: types.maybe(types.string),
  assignedUserID: types.maybe(types.string),
  inquiryType: types.maybeNull(types.string),
  referredVia: types.maybe(types.array(types.string)),
  savedAt: types.maybe(types.Date),
  updatedAt: types.maybe(types.Date),
});

export type InquiryModelType = Instance<typeof Inquiry>;
